export const hasFlag = (flags: number, flagPosition: number) => {
    return (flags & flagPosition) !== 0;
};
